import type { SupportedLanguage } from '../i18n';

export const localeForLanguage = (language: SupportedLanguage): string =>
  language === 'ar' ? 'ar-EG' : 'en-US';

export const formatNumber = (
  value: number,
  language: SupportedLanguage,
  options?: Intl.NumberFormatOptions
): string => new Intl.NumberFormat(localeForLanguage(language), options).format(value);

export const formatCurrency = (
  value: number,
  language: SupportedLanguage,
  currency = 'EGP'
): string =>
  new Intl.NumberFormat(localeForLanguage(language), {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value);

export const formatDate = (
  value: Date,
  language: SupportedLanguage,
  options?: Intl.DateTimeFormatOptions
): string =>
  new Intl.DateTimeFormat(
    localeForLanguage(language),
    options || { year: 'numeric', month: 'short', day: 'numeric' }
  ).format(value);

export const formatRelativeTime = (
  value: Date,
  language: SupportedLanguage,
  now: Date = new Date()
): string => {
  const diffMs = now.getTime() - value.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  const formatter = new Intl.RelativeTimeFormat(localeForLanguage(language), {
    numeric: 'auto',
  });

  if (diffMins < 1) return formatter.format(0, 'minute');
  if (diffMins < 60) return formatter.format(-diffMins, 'minute');
  if (diffHours < 24) return formatter.format(-diffHours, 'hour');
  if (diffDays < 7) return formatter.format(-diffDays, 'day');
  return formatDate(value, language);
};
